import styled from "styled-components";

export default styled.div`
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
